import { appleObject, appleUuid, appleHash, parseAppleCalendarPayload, isAppleCalendarActor, type AppleCalendarSealedReview } from '../../supabase/functions/_shared/appleCalendarWriteDomain';
export interface AppleCalendarPending {
  key:string; owner_id:string; review:AppleCalendarSealedReview;
  status:'pending'|'succeeded'; receipt_id?:string;
  origin?:{session_id:string;action_id:string};
}
async function transaction<T>(mode:IDBTransactionMode,work:(store:IDBObjectStore,done:(v:T)=>void)=>void):Promise<T>{
  const db=await new Promise<IDBDatabase>((resolve,reject)=>{
    const request=indexedDB.open('vyv-apple-calendar-writes',1);
    request.onupgradeneeded=()=>request.result.createObjectStore('writes',{keyPath:'key'});
    request.onsuccess=()=>resolve(request.result);request.onerror=request.onblocked=()=>reject(new Error('pending_storage_unavailable'));
  });
  return new Promise<T>((resolve,reject)=>{
    const tx=db.transaction('writes',mode);let value!:T;
    tx.oncomplete=()=>{db.close();resolve(value);};
    tx.onerror=tx.onabort=()=>{db.close();reject(new Error('pending_storage_unavailable'));};
    work(tx.objectStore('writes'),v=>{value=v;});
  });
}
function valid(v:unknown,owner:string):v is AppleCalendarPending{
  if(!appleObject(v)||v.key!==owner||v.owner_id!==owner||!['pending','succeeded'].includes(String(v.status))||!appleObject(v.review))return false;
  const review=v.review;
  try {parseAppleCalendarPayload(review.payload);}catch{return false;}
  return isAppleCalendarActor(review.actor)&&review.actor.owner_id===owner&&appleHash(review.request_hash)&&appleObject(review.native)&&
    appleUuid(review.native.review_id)&&appleHash(review.native.native_review_hash)&&
    (v.receipt_id===undefined||appleUuid(v.receipt_id))&&
    (v.origin===undefined||appleObject(v.origin)&&appleUuid(v.origin.session_id)&&appleUuid(v.origin.action_id));
}
export const appleCalendarJournal={
  load:async(owner:string):Promise<AppleCalendarPending|null>=>transaction('readonly',(store,done)=>{
    const req=store.get(owner);req.onsuccess=()=>{
      if(req.result===undefined){done(null);return;}
      if(!valid(req.result,owner)){store.transaction.abort();return;}done(req.result);
    };
  }),
  claim:async(entry:AppleCalendarPending):Promise<void>=>{
    if(!valid(entry,entry.owner_id))throw new Error('pending_storage_unavailable');
    return transaction('readwrite',(store,done)=>{
      const req=store.get(entry.key);req.onsuccess=()=>{
        if(req.result!==undefined){store.transaction.abort();return;}store.add(entry);done(undefined);
      };
    });
  },
  update:async(entry:AppleCalendarPending):Promise<void>=>{
    if(!valid(entry,entry.owner_id))throw new Error('pending_storage_unavailable');
    return transaction('readwrite',(store,done)=>{
      const req=store.get(entry.key);req.onsuccess=()=>{
        const old=req.result;
        if(!valid(old,entry.owner_id)||old.review.request_hash!==entry.review.request_hash||
          old.review.payload.operation_id!==entry.review.payload.operation_id){store.transaction.abort();return;}
        store.put(entry);done(undefined);
      };
    });
  },
  clear:async(entry:AppleCalendarPending):Promise<void>=>transaction('readwrite',(store,done)=>{
    const req=store.get(entry.key);req.onsuccess=()=>{
      if(!valid(req.result,entry.owner_id)||req.result.review.request_hash!==entry.review.request_hash){store.transaction.abort();return;}
      store.delete(entry.key);done(undefined);
    };
  }),
};
